// extracted by mini-css-extract-plugin
export default {"customList":"Legend_customList__12-9C","legendHeader":"Legend_legendHeader__TF1Nd","listItem":"Legend_listItem__OQxs4"};